export default __webpack_public_path__ + "static/media/m24.9974c470.jpg";